const rankData = [
	{
		rank: 'Fresh Start',
		emoji: '🌱',
		minScore: 0,
		maxScore: 800,
		vibe: 'Everyone starts somewhere'
	},
	{
		rank: 'Getting Moving',
		emoji: '🚶',
		minScore: 801,
		maxScore: 2000,
		vibe: 'Look at you go!'
	},
	{
		rank: 'Finding Flow',
		emoji: '💪',
		minScore: 2001,
		maxScore: 4000,
		vibe: "You're finding your rhythm"
	},
	{
		rank: 'Steady Climber',
		emoji: '🧗',
		minScore: 4001,
		maxScore: 6500,
		vibe: 'Consistency is your superpower'
	},
	{
		rank: 'On Fire',
		emoji: '🔥',
		minScore: 6501,
		maxScore: 10000,
		vibe: "You're crushing it!"
	},
	{
		rank: 'Leveling Up',
		emoji: '⚡',
		minScore: 10001,
		maxScore: 15000,
		vibe: 'The results are showing'
	},
	{
		rank: 'Strong & Steady',
		emoji: '🏋️',
		minScore: 15001,
		maxScore: 20500,
		vibe: 'You inspire others'
	},
	{
		rank: 'Peak Form',
		emoji: '🌄',
		minScore: 20501,
		maxScore: 27000,
		vibe: "That's seriously impressive"
	},
	{
		rank: 'Hall of Famer',
		emoji: '🏅',
		minScore: 27001,
		maxScore: 35000,
		vibe: "You've earned your spot"
	},
	{
		rank: 'Living Legend',
		emoji: '✨',
		minScore: 35001,
		maxScore: Infinity,
		vibe: 'This is who you are now'
	}
];

export default rankData;
